import { render } from "./app-icon-loading.vue?vue&type=template&id=1ed1904b"
import script from "./app-icon-loading.vue?vue&type=script&lang=js"
export * from "./app-icon-loading.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ed1904b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ed1904b', __exports__)) {
    console.log('reload')
    api.reload('1ed1904b', __exports__)
  }
  
  module.hot.accept("./app-icon-loading.vue?vue&type=template&id=1ed1904b", () => {
    console.log('re-render')
    api.rerender('1ed1904b', render)
  })

}


export default __exports__